import PropTypes from 'prop-types';
import React, { useState, useEffect, useCallback } from 'react';
import {
  calculatePrice, productUrl, productImage, productDescription,
} from '@snapbrains/snapav/src/avantlink';

import SaleTagFull from './parts/sale_tag_full';
import Commision from './parts/commission';
import Merchant from './parts/merchant';

// TODO move this into a defines
const screenSmall = 768;
function getViewPort() {
  return {
    viewport: {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
    },
  };
}

function getStyles(viewport, settings) {
  const styles = {
    container: {
      display: 'block',
      position: 'relative',
      padding: 10,
      margin: '2px 10px 0 0',
      borderLeftWidth: 5,
      borderRadius: 3,
      width: '100%',
      height: 'auto',
      float: 'none',
    },
    p: {
    },
  };

  // Columns calculation
  if (viewport.width > screenSmall) {
    const containerMargin = 2;
    const columns = parseInt(settings.columns, 10);
    styles.container.width = `${(100 / columns) - containerMargin}%`;
    if (columns > 1) {
      styles.container.float = 'left';
      styles.container.marginRight = `${containerMargin}%`;
      switch (columns) {
      case 2:
        styles.container.height = 230;
        styles.p.height = 120;
        break;
      case 3:
        styles.container.height = 220;
        break;
      case 4:
        styles.container.height = 270;
        break;
      default:
        styles.p.marginRight = 0;
        styles.p.height = 72;
        styles.container.height = 270;
      }
    }
  }

  if (settings.backgroundColor) {
    styles.container.backgroundColor = settings.backgroundColor;
  }

  return styles;
}

export default function ResultDetailed(props) {
  const [viewPort, setViewPort] = useState(getViewPort());

  const resizer = useCallback(() => {
    setViewPort(getViewPort());
  }, [setViewPort]);

  useEffect(() => {
    window.addEventListener('resize', resizer);
    return () => {
      window.removeEventListener('resize', resizer);
    };
  }, [resizer]);

  const { result, settings } = props;
  const {
    forAffiliate = false,
    resultMetaRenderer = null,
    resultHeaderRenderer = null,
  } = settings;
  const calculatedPricing = calculatePrice(result);
  const url = productUrl(
    result,
    settings.avantlinkWebsiteId,
    settings.trackingCode,
    settings.appId,
  );
  const image = productImage(result);
  const description = productDescription(result);
  const buttonText = settings.buttonText || 'View';
  const target = settings.openNewWindow ? '_blank' : '_self';
  const style = getStyles(viewPort, settings);

  return (
    <div className="snapgadget-result" style={style.container}>
      {resultHeaderRenderer && resultHeaderRenderer(props)}
      <h4><a target={target} href={url} rel="nofollow">{result.strProductName}</a></h4>
      <div className="snapgadget-content">
        <img src={image} alt={result.strProductName} />
        <p style={style.p}>{description}</p>
      </div>
      <div className={`snapgadget-original-price ${calculatedPricing.saleClass}`}>
        <SaleTagFull
          settings={settings}
          onSale={calculatedPricing.onSale}
          salePercent={calculatedPricing.salePercent}
          salePrice={result.dblProductSalePrice}
          url={url}
        />
        <a target={target} href={url} rel="nofollow">
          $
          {calculatedPricing.price}
        </a>
      </div>
      <div className="snapgadget-footer">
        <div className="snapgadget-merchant">
          <a href={url} target={target} rel="nofollow">{result.strMerchantName}</a>
        </div>
        <Merchant
          display
          containerClassName="snapgadget-merchant"
          url={url}
          target={target}
          result={result}
        />
        <div className="snapgadget-buy-it">
          <a target={target} className="snapgadget-btn" href={url} rel="nofollow">{buttonText}</a>
        </div>
      </div>
      {
        forAffiliate && (
          <Commision result={result} />
        )
      }
      {resultMetaRenderer && resultMetaRenderer(props)}
    </div>
  );
}

ResultDetailed.propTypes = {
  settings: PropTypes.shape({
    forAffiliate: PropTypes.bool,
    buttonText: PropTypes.string,
    appId: PropTypes.number,
    avantlinkWebsiteId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    trackingCode: PropTypes.string,
    openNewWindow: PropTypes.bool,
    resultMetaRenderer: PropTypes.func,
    resultHeaderRenderer: PropTypes.func,
  }).isRequired,
  result: PropTypes.shape({
    strProductName: PropTypes.string,
    strMerchantName: PropTypes.string,
    lngProductId: PropTypes.string,
    dblProductSalePrice: PropTypes.string,
  }).isRequired,
};
